import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinthane() {



  const cardData =
  {
    keyword: 'Cab Service in Thane ',
    heading: 'Shambhu Cabs: Cab Service in Thane',
    headingDescription: 'Shambhu Cabs offers dependable Cab Service in Thane, providing safe, comfortable, and convenient travel for daily commuters, families, corporate professionals, and travelers across the city. Our fleet of hatchbacks, sedans, SUVs, and premium vehicles ensures smooth transportation for local rides, airport transfers, outstation trips, and full-day rentals. With flexible booking options — one-way, round-trip, hourly, or daily — and doorstep pickup across all neighborhoods in Thane, Shambhu Cabs makes your travel hassle-free. Backed by experienced chauffeurs, GPS-enabled cars, transparent pricing, and 24/7 customer support, we ensure a reliable and stress-free ride every time.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Upvan Lake",
    "description": "Upvan Lake is Thane’s most popular recreational landmark, known for its serene waters, jogging tracks, and the backdrop of the Yeoor Hills. The lake is beautifully lit at night and becomes the center of attraction during cultural events like the Sanskruti Arts Festival. Visitors enjoy peaceful evening walks, lakeside seating, and street food stalls, making it a perfect leisure and photography destination in the heart of Thane."
  },
  {
    "title": "Yeoor Hills",
    "description": "Yeoor Hills, part of the Sanjay Gandhi National Park, is Thane’s natural retreat offering lush greenery, trekking trails, birdwatching, and scenic viewpoints. The area is home to a variety of flora and fauna including leopards, deer, and exotic bird species. With its clean air, forest environment, and peaceful surroundings, Yeoor Hills is ideal for nature lovers, trekkers, and those seeking a refreshing escape from urban life."
  },
  {
    "title": "Kanheri Caves (via SGNP)",
    "description": "Though located inside Sanjay Gandhi National Park, the Kanheri Caves are easily accessible from Thane and are among the oldest Buddhist cave monuments in India. Dating back to the 1st century BCE, the caves feature stone-carved prayer halls, intricate inscriptions, sculptures of Buddha, and ancient monasteries. The site offers a blend of history, spirituality, and trekking through lush forest landscapes."
  },
  {
    "title": "Talao Pali (Masunda Lake)",
    "description": "Masunda Lake, popularly known as Talao Pali, is one of Thane’s most iconic lakes featuring paddle boating, evening lights, street food stalls, and a charming lakeside promenade. The lake has a Ganesh temple on its banks and is a favorite spot for families, couples, and walkers. It is a vibrant recreational hub surrounded by lively markets, eateries, and cultural activities."
  },
  {
    "title": "Ghodbunder Fort",
    "description": "Ghodbunder Fort is a historic 16th-century fort built by the Portuguese and later occupied by the Marathas. Overlooking the Ulhas River, the fort features old bastions, watchtowers, stone walls, and scenic viewpoints. Though partially in ruins, it offers a glimpse into Thane’s strategic maritime history and is a popular photography and exploration spot among local history enthusiasts."
  },
  {
    "title": "Suraj Water Park",
    "description": "Suraj Water Park is one of Thane’s favorite family-friendly attractions, featuring thrilling water slides, wave pools, rain dance areas, and relaxation zones. The park has won several awards for cleanliness and entertainment value. Its unique fiberglass dome, vibrant atmosphere, and variety of rides make it an ideal destination for kids, families, and group outings."
  },
  {
    "title": "Ovalekar Wadi Butterfly Garden",
    "description": "Ovalekar Wadi Butterfly Garden is a nature lover’s paradise where over 130 species of butterflies can be observed in their natural habitat. Visitors learn about the life cycle of butterflies, nectar plants, and conservation efforts. The serene garden walk, guided tours, and vibrant butterfly sightings offer an educational and enriching experience perfect for families and photographers."
  },
  {
    "title": "Kelva Beach (near Thane)",
    "description": "Kelva Beach, located around 60–70 km from Thane, is a peaceful and expansive coastline known for its greenery, horse rides, watchtower, and calm waves. It remains less crowded than Mumbai’s beaches and offers clean surroundings, making it ideal for sunsets, picnics, and weekend relaxation. Nearby Kelva Fort adds a touch of history to the scenic beachside visit."
  },
  {
    "title": "Vandana Lake",
    "description": "Vandana Lake is a quiet and scenic waterbody surrounded by residential areas, ideal for morning walks, jogging, and peaceful relaxation. Though smaller than other lakes in Thane, it offers a clean, green environment, making it a preferred spot for locals seeking a calm neighborhood retreat."
  },
  {
    "title": "Kopri Fort (Thane Creek)",
    "description": "Kopri Fort is a lesser-known heritage structure situated near Thane Creek. Though mostly in ruins, it holds historical significance from the Portuguese era and served as a watchpoint overlooking the creek. Its location provides beautiful views of the mangroves, creek waters, and local fishing activities, making it an offbeat spot for history and photography enthusiasts."
  }
],




"services": [
  {
    "name": "Thane Taxi Service",
    "description": "Thane Taxi Service provides reliable and professional taxi solutions for local travel within Thane as well as outstation trips. The service ensures well-maintained vehicles, experienced drivers, and timely pickups for a safe and comfortable journey. Ideal for daily commutes, airport transfers, corporate travel, or leisure trips, this service combines convenience, affordability, and round-the-clock availability. Customers can choose from a range of vehicles including sedans, SUVs, and premium cabs with options for AC and non-AC rides, and can easily book online for hassle-free travel."
  },
  {
    "name": "Thane Local Cabs",
    "description": "Thane Local Cabs offers convenient point-to-point transportation within the city, making it easy to travel quickly and efficiently. With a fleet of clean sedans, SUVs, and premium vehicles, passengers experience comfortable rides with professional drivers. The service is ideal for office commutes, shopping trips, or family outings, providing 24×7 availability, online booking, and transparent pricing for stress-free local travel in Thane."
  },
  {
    "name": "Cab Near Me Thane",
    "description": "Cab Near Me Thane allows customers to locate and book nearby cabs instantly for local or outstation travel. With GPS-enabled vehicles, experienced chauffeurs, and a range of vehicle options including AC and non-AC sedans and SUVs, this service guarantees safe, timely, and comfortable rides. Ideal for both regular and urgent travel, passengers can enjoy hassle-free online booking, flexible schedules, and competitive pricing."
  },
  {
    "name": "Affordable Cabs Thane",
    "description": "Affordable Cabs Thane provides budget-friendly taxi options for local and outstation travel without compromising on comfort and safety. The service offers sedans, SUVs, and premium vehicles with professional drivers, punctual pickups, and transparent fare estimates. Perfect for family trips, airport transfers, and business travel, customers can book online and enjoy cost-effective yet reliable taxi services in Thane."
  },
  {
    "name": "24×7 Cab Thane",
    "description": "24×7 Cab Thane ensures round-the-clock availability for all travel needs within and outside Thane. Whether it's an urgent airport transfer, late-night ride, or early morning commute, this service guarantees professional drivers, clean vehicles, and timely pickups. With options ranging from sedans to SUVs, passengers can enjoy a safe, reliable, and convenient travel experience at any time of day or night."
  },
  {
    "name": "Best Cabs in Thane",
    "description": "Best Cabs in Thane offers premium and well-maintained vehicles with professional drivers to provide top-notch taxi services. Suitable for corporate travel, family outings, airport transfers, and city tours, this service emphasizes safety, comfort, and punctuality. Customers can choose from sedans, SUVs, and premium cars with flexible booking options and transparent pricing for a seamless travel experience."
  },
  {
    "name": "Sedan Cab Thane",
    "description": "Sedan Cab Thane specializes in comfortable, smooth rides in well-maintained sedan vehicles. Ideal for small families, corporate passengers, or solo travelers, the service provides professional drivers, online booking, and timely pickups. Available for both local city travel and outstation trips, this service ensures a safe, relaxing, and hassle-free journey in Thane."
  },
  {
    "name": "SUV Cab Thane",
    "description": "SUV Cab Thane provides spacious and comfortable rides for families, groups, or travelers with extra luggage. With experienced chauffeurs, fully maintained vehicles, and 24×7 availability, the service guarantees safe and convenient travel. Perfect for airport transfers, city tours, or long-distance outstation trips, customers can book online and enjoy premium travel comfort in Thane."
  },
  {
    "name": "Thane Airport Taxi",
    "description": "Thane Airport Taxi offers convenient and reliable airport transfers with timely pickups and professional drivers. Available for departures and arrivals at major airports near Thane, this service ensures a stress-free journey in sedans, SUVs, or premium cars. With online booking, real-time tracking, and 24×7 availability, passengers can travel safely and comfortably to and from the airport."
  },
  {
    "name": "Thane Outstation Cab",
    "description": "Thane Outstation Cab provides long-distance travel options for trips from Thane to nearby cities and towns. With well-maintained sedans, SUVs, and premium vehicles, experienced drivers, and transparent pricing, this service ensures a smooth, safe, and comfortable journey. Perfect for family vacations, corporate trips, or leisure travel, bookings are available online with flexible schedules and 24×7 support."
  },
  {
    "name": "Thane City Cab Service",
    "description": "Thane City Cab Service delivers efficient point-to-point transportation within the city for business, shopping, or leisure trips. With a range of vehicles including sedans and SUVs, professional drivers, and 24×7 service, passengers can enjoy reliable, safe, and comfortable rides. Online booking and transparent pricing make city travel in Thane convenient and stress-free."
  },
  {
    "name": "Fast Cab Service Thane",
    "description": "Fast Cab Service Thane focuses on quick and efficient travel within the city and nearby areas. With experienced drivers, GPS-enabled vehicles, and prompt pickups, this service is ideal for office commutes, urgent airport transfers, or time-sensitive trips. Customers can book online and choose from sedans, SUVs, and premium vehicles for a safe and fast travel experience."
  },
  {
    "name": "Corporate Cab Thane",
    "description": "Corporate Cab Thane provides professional transportation solutions for businesses and corporate clients. Services include employee commutes, airport transfers, client pickups, and outstation corporate travel. With experienced drivers, well-maintained sedans and SUVs, flexible scheduling, and 24×7 support, this service ensures safe, comfortable, and timely travel for companies in Thane."
  },
  {
    "name": "Safe Cab Thane",
    "description": "Safe Cab Thane prioritizes passenger safety with well-maintained vehicles, experienced drivers, and adherence to traffic rules. Available for local, outstation, and airport travel, the service includes sedans, SUVs, and premium cars. With 24×7 support, transparent pricing, and online booking, passengers can enjoy secure, comfortable, and worry-free journeys in Thane."
  },
  {
    "name": "Thane Pickup Drop Cab",
    "description": "Thane Pickup Drop Cab ensures convenient point-to-point travel within Thane for home, office, or airport transfers. With professional drivers, timely pickups, and clean, comfortable vehicles, this service offers a stress-free travel experience. Customers can choose from sedans, SUVs, or premium cars, book online, and enjoy flexible scheduling for both regular and one-time travel needs."
  },
  {
    "name": "Online Cab Booking Thane",
    "description": "Online Cab Booking Thane allows passengers to book cabs digitally for local, outstation, or airport travel. With instant confirmation, flexible vehicle options, and secure payment gateways, this service ensures a smooth and convenient booking process. Passengers can select from sedans, SUVs, or premium cars with professional drivers for reliable and timely transportation."
  },
  {
    "name": "Premium Cab Service Thane",
    "description": "Premium Cab Service Thane provides luxury and executive transportation options for travelers seeking comfort and style. With top-end sedans and SUVs, professional chauffeurs, well-maintained vehicles, and 24×7 support, the service caters to corporate clients, VIP passengers, and special occasions. Online booking, transparent pricing, and flexible scheduling ensure a premium travel experience in Thane."
  }
],

"tableData": [
  ["Thane Taxi Service", "Thane Local Cabs"],
  ["Cab Near Me Thane", "Affordable Cabs Thane"],
  ["24×7 Cab Thane", "Best Cabs in Thane"],
  ["Sedan Cab Thane", "SUV Cab Thane"],
  ["Thane Airport Taxi", "Thane Outstation Cab"],
  ["Thane City Cab Service", "Fast Cab Service Thane"],
  ["Corporate Cab Thane", "Safe Cab Thane"],
  ["Thane Pickup Drop Cab", "Online Cab Booking Thane"],
  ["Premium Cab Service Thane", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Thane with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable cab services in Thane, ideal for daily commutes, airport transfers, and city travel with comfort and safety."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and comfortable journey across Thane."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Thane Roads",
    "WhyChoosedescription": "Our professional drivers are knowledgeable about Thane’s routes, ensuring timely, smooth, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide upfront pricing—fuel, tolls, and driver allowances included—making your cab service in Thane stress-free and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for City Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your travel requirements in Thane."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your travel in Thane smooth, comfortable, and worry-free."
  }
]























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab services in Thane?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services in Thane for local travel, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a cab in Thane with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free bookings.',
  },
  {
    question: 'What types of vehicles are available for cab service in Thane?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars suitable for individual, family, and corporate travel in Thane.',
  },
  {
    question: 'Are drivers experienced for cab services in Thane?',
    answer: 'Yes, our drivers are licensed, professional, and well-versed with Thane city routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for cab service in Thane?',
    answer: 'Absolutely. You can select any pickup and drop-off points according to your convenience within Thane.',
  },
  {
    question: 'Is cab service available 24x7 in Thane?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock cab services in Thane to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab services in Thane?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for cab service in Thane?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during cab journeys in Thane?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your cab journey in Thane.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'Shambhu Cabs made traveling within Thane very convenient. The driver was professional and the car was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Patil',
    feedback: 'Reliable and timely cab service in Thane. Highly recommend Shambhu Cabs for local travel and airport transfers.',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Thane",
  "image": "https://www.shambhucab.com/assets/images/thane-cab-service.jpg",
  "description": "Shambhu Cabs provides reliable cab services in Thane, including local rides, airport transfers, outstation trips, and corporate travel. Choose from sedans, SUVs, and premium cabs. Available 24×7 with safe, affordable, and online booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "900",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/cab-service-in-thane"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Service in Thane | Local, Airport & Outstation Cabs | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book cab services in Thane with Shambhu Cabs. Sedans, SUVs, and premium cabs for local rides, airport transfers, outstation trips, and corporate travel. Safe, reliable, and available 24×7 with online booking."
  />

  <meta
    name="keywords"
    content="Thane Taxi Service, Thane Local Cabs, Cab Near Me Thane, Affordable Cabs Thane, 24×7 Cab Thane, Best Cabs in Thane, Sedan Cab Thane, SUV Cab Thane, Thane Airport Taxi, Thane Outstation Cab, Thane City Cab Service, Fast Cab Service Thane, Corporate Cab Thane, Safe Cab Thane, Thane Pickup Drop Cab, Online Cab Booking Thane, Premium Cab Service Thane"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinthane;